export const paymentMethodToStripeTypes = {
    "Credit Card": "card",
    "ACSS": "acss_debit",
    "BACS": "bacs_debit",
    "SEPA": "sepa_debit"
}

export const paymentMethodTypeToPaymentData = {
    card(collectedPaymentData) {
        return collectedPaymentData;
    },
    sepa_debit(collectedPaymentData) {
        return collectedPaymentData
    },
    acss_debit(collectedPaymentData) {
        return {
            institution_number: collectedPaymentData.institutionNumber,
            transit_number: collectedPaymentData.transitNumber,
            account_number: collectedPaymentData.accountNumber,
        };
    },
    bacs_debit(collectedPaymentData) {
        return {
            sort_code: collectedPaymentData.sortCode,
            account_number: collectedPaymentData.accountNumber,
        };
    }
}

export const confirmIntentToStripeMethod = {
    payment: {
        card: 'confirmCardPayment',
        sepa_debit: 'confirmSepaDebitPayment',
        acss_debit: 'confirmAcssDebitPayment',
        bacs_debit: 'confirmBacsDebitPayment',
    },
    setUp: {
        card: 'confirmCardSetup',
        sepa_debit: 'confirmSepaDebitSetup',
        acss_debit: 'confirmAcssDebitSetup',
        bacs_debit: 'confirmBacsDebitSetup',
    }
}
